<div class="dash">
    <div class="dash-card no-padding">
        <div class="dash-card-header d-block">
            <div style="flex-direction: column;">
                <div class="row w-100 no-gutters">
                    <div class="col-12">
                        <h2>Tipos de documento</h2>
                    </div>

                    <div class="col-12 d-flex justify-content-end mt-3">
                        <app-button
                            *ngIf="hasFilters && permissionObj.canFilter"
                            [danger]="true" [outline]="true" class="mr-2"
                            (onClick)="resetForm()" [disabled]="loading">
                            <i
                                class="fas fa-times filter-clear-icon mt-1 mb-1 mr-2"></i>
                            Limpar filtros
                        </app-button>

                        <app-button [inverted]="true" class="add-button mr-2"
                            (onClick)="showFilterModal = true"
                            *ngIf="permissionObj.canFilter"
                            [disabled]="loading">
                            <svg-icon
                                src="assets/images/icon_filter.svg"></svg-icon>
                            {{ hasFilters ? 'Editar filtros' : 'Aplicar filtros'
                            }}
                        </app-button>

                        <app-button (onClick)="addDraft()" class="add-button"
                            *ngIf="permissionObj.canAdd">
                            <svg-icon src="assets/images/icon-add.svg"
                                class="mr-2 mb-1"></svg-icon>
                            Adicionar tipo de documento
                        </app-button>
                    </div>
                </div>

                <div class="col-12 mt-3 px-0"
                    *ngIf="!loading && hasFilters && appliedFilters.length > 0">
                    <div
                        class="d-flex flex-wrap align-items-center justify-content-end">
                        <app-filter-tag *ngFor="let filter of appliedFilters"
                            [label]="filter.label" [value]="filter.value">
                        </app-filter-tag>
                    </div>
                </div>
            </div>
        </div>

        <div class="dash-card-body padding-container">
            <ng-container *ngIf="loading">
                <table #table>
                    <thead>
                        <tr>
                            <th>
                                <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '125px',
                                        marginBottom:'0'
                                      }">
                                </ngx-skeleton-loader>
                            </th>

                            <th>
                                <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '125px',
                                        marginBottom:'0'
                                      }">
                                </ngx-skeleton-loader>
                            </th>

                            <th>
                                <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '125px',
                                        marginBottom:'0'
                                      }">
                                </ngx-skeleton-loader>
                            </th>

                            <th>
                                <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '125px',
                                        marginBottom:'0'
                                      }">
                                </ngx-skeleton-loader>
                            </th>

                            <th>
                                <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '125px',
                                        marginBottom:'0'
                                      }">
                                </ngx-skeleton-loader>
                            </th>

                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let number of [0,1,2,3,4,5,6]">
                            <td>
                                <ngx-skeleton-loader [theme]="{
                                            height: '15px',
                                            width: '200px',
                                        marginBottom:'0'
                                          }">
                                </ngx-skeleton-loader>
                            </td>
                            <td>
                                <ngx-skeleton-loader [theme]="{
                                            height: '15px',
                                            width: '120px',
                                        marginBottom:'0'
                                          }">
                                </ngx-skeleton-loader>
                            </td>
                            <td>
                                <ngx-skeleton-loader [theme]="{
                                            height: '15px',
                                            width: '120px',
                                        marginBottom:'0'
                                          }">
                                </ngx-skeleton-loader>
                            </td>
                            <td>
                                <ngx-skeleton-loader [theme]="{
                                            height: '15px',
                                            width: '150px',
                                        marginBottom:'0'
                                          }">
                                </ngx-skeleton-loader>
                            </td>
                            <td>
                                <ngx-skeleton-loader [theme]="{
                                            height: '24px',
                                            width: '80px',
                                        marginBottom:'0'
                                          }">
                                </ngx-skeleton-loader>
                            </td>
                            <td>
                                <div
                                    class="d-flex align-items-center justify-content-end">
                                    <ngx-skeleton-loader [theme]="{
                                            height: '32px',
                                            width: '32px',
                                            marginRight: '8px',
                                            marginBottom:'0'
                                          }">
                                    </ngx-skeleton-loader>
                                    <ngx-skeleton-loader [theme]="{
                                            height: '32px',
                                            width: '32px',
                                            marginBottom:'0'
                                          }">
                                    </ngx-skeleton-loader>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>

            <table class="bordered"
                *ngIf="!loading && (data.length > 0 || hasFilters)">
                <thead>
                    <tr>
                        <th>Tipo de documento</th>
                        <th>Data de criação</th>
                        <th>Última atualização</th>
                        <th>Evento vinculado</th>
                        <th>Status</th>
                        <th></th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let item of data">
                        <td>{{item.name}}</td>

                        <td>
                            {{item.created_at | date: 'dd/MM/yyyy HH:mm'}}
                        </td>

                        <td>
                            {{item.updated_at | date: 'dd/MM/yyyy HH:mm'}}
                        </td>

                        <td>
                            {{item.event || 'Nenhum evento vinculado'}}
                        </td>

                        <td>
                            <div class="status-tag"
                                [class.-inactive]="!item.status">
                                {{item.status ? 'Ativo' : 'Inativo'}}
                            </div>
                        </td>

                        <td>
                            <div class="dash-card-item-buttons">
                                <button class="dash-item-button"
                                    (click)="editDraft(item.id)"
                                    *ngIf="permissionObj.canEdit">
                                    <svg-icon
                                        src="assets/images/icon-edit.svg"></svg-icon>
                                </button>
                                <app-spacer [right]="16"></app-spacer>

                                <button class="dash-item-button"
                                    (click)="toggleDraftStatus(item.id)"
                                    *ngIf="permissionObj.canChange">
                                    <svg-icon src="assets/images/icon-ban.svg"
                                        *ngIf="item.status"></svg-icon>
                                    <svg-icon src="assets/images/icon-check.svg"
                                        *ngIf="!item.status"></svg-icon>
                                </button>
                                <!-- <app-spacer [right]="16"></app-spacer>

                                <button class="dash-item-button"
                                    (click)="redirectToDetails(item.id)">
                                    <svg-icon src="assets/images/icon-eye.svg"></svg-icon>
                                </button> -->
                            </div>
                        </td>
                    </tr>

                    <tr *ngIf="data.length === 0">
                        <td>Nenhum tipo de documento encontrado</td>
                    </tr>

                </tbody>
                <app-spacer [bottom]="28"></app-spacer>
            </table>

            <ng-container *ngIf="!loading && data.length === 0 && !hasFilters">
                <app-empty-content [isVisible]="true" [large]="true"
                    *ngIf="!permissionObj.canAdd"
                    title="Não há nenhum tipo de documento para exibir"
                    description="Não há tipos de documentos para serem exibidos no momento, para adicionar um novo tipo de documento clique no botão abaixo."
                    icon="/assets/images/figure_3d_search.png">
                </app-empty-content>

                <app-empty-content [isVisible]="true" [large]="true"
                    *ngIf="permissionObj.canAdd"
                    title="Não há nenhum tipo de documento para exibir"
                    description="Não há tipos de documentos para serem exibidos no momento, para adicionar um novo tipo de documento clique no botão abaixo."
                    icon="/assets/images/figure_3d_search.png"
                    (onClick)="addDraft()" [haveButtonIcon]="true"
                    buttonLabel="Adicionar tipo de documento">
                </app-empty-content>
            </ng-container>
        </div>
    </div>
</div>

<div class="col-12 ml-auto mr-auto" *ngIf="!loading && data.length > 0">
    <div class="dash-card-pagination">
        <app-pagination [data]="data" [count]="count" [show]="!loading"
            [offset]="offset" (onPageChange)="changePageData($event)"
            [dashPagination]="true" [resultsPerPage]="results_per_page">
        </app-pagination>
    </div>
</div>

<app-side-filter-modal [active]="showFilterModal" [formGroup]="filterForm"
    [loading]="loading" title="Filtrar listagem"
    (onClose)="showFilterModal = false" (onApply)="filterData()"
    (onReset)="resetForm()">
    <div class="row">
        <div class="col-12">
            <app-input [group]="filterForm" controlName="type_document"
                placeholder="Digite" label="Nome">
            </app-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12">
            <app-select [items]="statusOptions" [group]="filterForm"
                controlName="status" placeholder="Selecione" label="Status">
            </app-select>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12">
            <app-masked-input [group]="filterForm"
                controlName="created_at_after" mask="00/00/0000"
                label="Data de início" placeholder="dd/mm/aaaa">
            </app-masked-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12">
            <app-masked-input [group]="filterForm"
                controlName="created_at_before" mask="00/00/0000"
                label="Data final" placeholder="dd/mm/aaaa">
            </app-masked-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>
    </div>
</app-side-filter-modal>

<!-- Carbon Warning Modal para mudança de status -->
<app-carbon-warning-modal [active]="showStatusModal" [title]="getModalTitle()"
    [message]="getModalMessage()" [confirmText]="getConfirmText()"
    [cancelText]="'Não, manter como está'"
    [confirmAction]="confirmStatusChange.bind(this)"
    [cancelAction]="closeStatusModal.bind(this)" (onClose)="closeStatusModal()">
</app-carbon-warning-modal>